import React, {useRef, useState} from "react";
import useNearScreen from "./useNearScreen";
import PropTypes from "prop-types";

const EMPTY_HTML = {__html: ""};
const isServer = typeof window === "undefined";

const ProgressiveHydration = (props) => {
    const {preload, children, root, rootMargin, debug} = props;
    const [isServerRendered] = useState(() => (isServer ? true : !!window?.serverRendered));
    const ref = useRef(null);
    const isNearScreen = useNearScreen({
        ref,
        root,
        rootMargin,
        enable: isServerRendered,
    });

    if (debug) {
        console.log({isNearScreen});
    }
    // SERVER: Just render the content as usual
    // CLIENT : render when in viewport
    if (
        !isServerRendered ||
        isServer ||
        isNearScreen === true ||
        preload === true ||
        typeof clientOnly !== "undefined"
    ) {
        return <div ref={ref}>{children}</div>;
    }

    // CLIENT: Avoid hydration until we say so
    return <div ref={ref} suppressHydrationWarning dangerouslySetInnerHTML={EMPTY_HTML} />;
};
ProgressiveHydration.defaultProps = {
    preload: false,
    debug: false,
};
ProgressiveHydration.propTypes = {
    preload: PropTypes.bool,
    children: PropTypes.any,
    debug: PropTypes.bool,
    root: PropTypes.any,
    rootMargin: PropTypes.string,
};
export default ProgressiveHydration;
